module.exports = {
	"_args": [
		[
			"web3@1.3.3",
			"/vercel/path0"
		]
	],
	"_from": "web3@1.3.3",
	"_id": "web3@1.3.3",
	"_inBundle": false,
	"_integrity": "sha512-fI/g0yC1FC0m4envv8FsPh7tbBoe/eXbEho+iY/hahs7YGgGt3nYNrAFTkR9pLhQaVMpOilhwgFxXEp+O7My/g==",
	"_location": "/web3",
	"_phantomChildren": {
		"@ethersproject/address": "5.0.8",
		"@ethersproject/bignumber": "5.0.11",
		"@ethersproject/bytes": "5.0.7",
		"@ethersproject/constants": "5.0.7",
		"@ethersproject/hash": "5.0.8",
		"@ethersproject/keccak256": "5.0.6",
		"@ethersproject/logger": "5.0.8",
		"@ethersproject/properties": "5.0.6",
		"@ethersproject/strings": "5.0.7",
		"@types/bn.js": "4.11.6",
		"bluebird": "3.5.2",
		"brorand": "1.1.0",
		"bufferutil": "4.0.2",
		"content-hash": "2.5.2",
		"create-hash": "1.2.0",
		"crypto-browserify": "3.12.0",
		"debug": "2.6.9",
		"decompress-response": "3.3.0",
		"duplexer3": "0.1.4",
		"elliptic": "6.4.1",
		"es6-iterator": "2.0.3",
		"eth-ens-namehash": "2.0.8",
		"eth-lib": "0.1.29",
		"ethereum-bloom-filters": "1.0.6",
		"ethereum-cryptography": "0.1.3",
		"ethereumjs-common": "1.5.2",
		"ethjs-unit": "0.1.6",
		"ethjs-util": "0.1.6",
		"ext": "1.4.0",
		"get-stream": "3.0.0",
		"got": "9.6.0",
		"graceful-fs": "4.1.11",
		"hash.js": "1.1.5",
		"hmac-drbg": "1.0.1",
		"http-https": "1.0.0",
		"inherits": "2.0.3",
		"is-arguments": "1.1.0",
		"is-generator-function": "1.0.8",
		"is-plain-obj": "1.1.0",
		"is-retry-allowed": "1.2.0",
		"is-stream": "1.1.0",
		"is-typed-array": "1.1.5",
		"isurl": "1.0.0",
		"lowercase-keys": "1.0.1",
		"mime-types": "2.1.20",
		"minimalistic-assert": "1.0.1",
		"minimalistic-crypto-utils": "1.0.1",
		"mkdirp-promise": "5.0.1",
		"mock-fs": "4.13.0",
		"next-tick": "1.0.0",
		"number-to-bn": "1.7.0",
		"p-timeout": "1.2.1",
		"prepend-http": "1.0.4",
		"safe-buffer": "5.1.2",
		"setimmediate": "1.0.5",
		"tar": "4.4.13",
		"timed-out": "4.0.1",
		"type": "1.2.0",
		"typedarray-to-buffer": "3.1.5",
		"universalify": "0.1.2",
		"url-to-options": "1.0.1",
		"utf-8-validate": "5.0.3",
		"utf8": "3.0.0",
		"uuid": "3.3.2",
		"web3-core-method": "1.3.3",
		"which-typed-array": "1.1.4",
		"xhr-request": "1.1.0",
		"xhr-request-promise": "0.1.2",
		"xhr2-cookies": "1.1.0",
		"yaeti": "0.0.6"
	},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "web3@1.3.3",
		"name": "web3",
		"escapedName": "web3",
		"rawSpec": "1.3.3",
		"saveSpec": null,
		"fetchSpec": "1.3.3"
	},
	"_requiredBy": [
		"/",
		"/@types/web3",
		"/ethereum-ens",
		"/openzeppelin-test-helpers"
	],
	"_resolved": "https://registry.npmjs.org/web3/-/web3-1.3.3.tgz",
	"_spec": "1.3.3",
	"_where": "/vercel/path0",
	"author": {
		"name": "ethereum.org"
	},
	"authors": [
		{
			"name": "Fabian Vogelsteller",
			"email": "fabian@ethereum.org",
			"homepage": "http://frozeman.de"
		},
		{
			"name": "Marek Kotewicz",
			"email": "marek@parity.io",
			"url": "https://github.com/debris"
		},
		{
			"name": "Marian Oancea",
			"url": "https://github.com/cubedro"
		},
		{
			"name": "Gav Wood",
			"email": "g@parity.io",
			"homepage": "http://gavwood.com"
		},
		{
			"name": "Jeffery Wilcke",
			"email": "jeffrey.wilcke@ethereum.org",
			"url": "https://github.com/obscuren"
		}
	],
	"bugs": {
		"url": "https://github.com/ethereum/web3.js/issues"
	},
	"dependencies": {
		"web3-bzz": "1.3.3",
		"web3-core": "1.3.3",
		"web3-eth": "1.3.3",
		"web3-eth-personal": "1.3.3",
		"web3-net": "1.3.3",
		"web3-shh": "1.3.3",
		"web3-utils": "1.3.3"
	},
	"description": "Ethereum JavaScript API",
	"devDependencies": {
		"@types/node": "^12.12.6",
		"dtslint": "^3.4.1",
		"typescript": "^3.9.5"
	},
	"engines": {
		"node": ">=8.0.0"
	},
	"gitHead": "d59d05e81da9fdb54b12b1aa20c95bf05036f00f",
	"homepage": "https://github.com/ethereum/web3.js#readme",
	"keywords": [
		"Ethereum",
		"JavaScript",
		"API"
	],
	"license": "LGPL-3.0",
	"main": "lib/index.js",
	"name": "web3",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/ethereum/web3.js.git"
	},
	"scripts": {
		"dtslint": "dtslint --localTs ../../node_modules/typescript/lib types",
		"tsc": "tsc -b tsconfig.json"
	},
	"types": "types/index.d.ts",
	"version": "1.3.3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/web3/package.json
// module id = 999
// module chunks = 0